












import {Component, Prop, PropSync, Vue} from 'vue-property-decorator';
import {PopupRequestData} from '@/types';

@Component
export default class AdSmsNotice extends Vue {
  @PropSync('isShowNotice') private isShowNoticeSync!: boolean;
  @Prop() private type!: 'SMS' | 'EMAIL';

  private changeVisible() {
    this.isShowNoticeSync = false;
  }
  private noticeTextList = [
    'MANAGE_SMS_AUTO_AD_NOTICE_TEXT_1',
    'MANAGE_SMS_AUTO_AD_NOTICE_TEXT_2',
  ]
  private adSmsNoticeData: PopupRequestData = {
    id: 'sms-notice',
    width: 700,
    maxHeight: 900,
    classStr: 'lp_large',
    title: this.type === 'SMS' ? 'MANAGE_SMS_AUTO_AD_NOTICE_TITLE_SMS' : 'MANAGE_SMS_AUTO_AD_NOTICE_TITLE_MAIL',
    hasConfirmBtn: false,
    hasCloseBtn: false,
    hasVerticalScroll: true
  };
}
